import i18next from 'i18next';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18next
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(Backend)
    .init<HttpBackendOptions>({
        debug: true,
        lowerCaseLng: true,
        fallbackLng: 'en',
        backend: {
            loadPath: '/qr-menu/locales/{{lng}}/{{ns}}.json'
        },
        detection: {
            order: ['sessionStorage'],
            caches: ['sessionStorage'],
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
export default i18next;